const loadMoreItems = (buttonId: string, url: string, containerId: string): void => {
    document.getElementById(buttonId)?.addEventListener('click', async function () {
        const button = this as HTMLButtonElement;
        let skip = parseInt(button.getAttribute('data-skip'));
        const take = 3; // Number of items to load each time

        try {
            const response = await fetch(`${url}?take=${take}&skip=${skip}`);
            const html = await response.text();

            if (html.trim() === "") {
                button.style.display = 'none'; // Hide the button if no more items
            } else {
                document.getElementById(containerId)?.insertAdjacentHTML('beforeend', html);
                button.setAttribute('data-skip', (skip + take).toString());

                // Check if there are more items
                const nextResponse = await fetch(`${url}?take=1&skip=${skip + take}`);
                const nextHtml = await nextResponse.text();

                if (nextHtml.trim() === "") {
                    button.style.display = 'none'; // Hide the button if no more items
                }
            }
        } catch (error) {
            console.error(`Error loading more items from ${url}:`, error);
        }
    });
}

const ArticleListItems = (): void => {
    loadMoreItems('load-more-drafts', '/load-more-drafts', 'draft-articles');
    loadMoreItems('load-more-articles', '/load-more-submitted', 'submitted-articles');
}

export default ArticleListItems;

